<template>
  <button :class="['button', classes, { 'disabled-btn': disabled }]" :disabled="disabled">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'Button',
  props: {
    grey: { type: Boolean, default: false },
    rectangular: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return {
        disabled: this.$props.disabled || this.$props.loading,
        grey: this.$props.grey,
        rectangular: this.$props.rectangular,
      };
    },
  },
};
</script>

<style lang="postcss" scoped>
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  padding: 0 var(--space-24);
  margin: 0;
  border: none;
  font-family: inherit;
  font-size: var(--font-size-14);
  font-weight: var(--medium);
  color: var(--grey);
  background-color: var(--background-grey);
  cursor: pointer;
  transition: var(--transition-all);
}

.disabled-btn {
  &:hover {
    color: var(--grey);

    &.grey {
      opacity: 0.7;
      color: var(--white);
    }
  }
}

.disabled {
  opacity: 0.3;
  cursor: auto;

  &.focus,
  &:hover,
  &:active {
    pointer-events: none !important;
    transform: none !important;
    box-shadow: none;
  }
}

.grey.disabled,
.light.disabled {
  opacity: 1;
}

.rectangular {
  border-radius: var(--round-corner-small);
}

.grey {
  background: var(--grey);
  color: var(--white);
}
</style>
